import React from "react";

// Elegant gold botanical divider — line art style
export const Ornament = ({ className = "" }) => (
  <svg
    viewBox="0 0 220 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M2 16 H92"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M218 16 H128"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M110 4 C 100 12, 100 20, 110 28 C 120 20, 120 12, 110 4 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />
    <circle cx="110" cy="16" r="1.6" fill="currentColor" />
    <path
      d="M92 16 q 6 -6, 12 0"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />
    <path
      d="M128 16 q -6 -6, -12 0"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />
    <circle cx="92" cy="16" r="1.2" fill="currentColor" />
    <circle cx="128" cy="16" r="1.2" fill="currentColor" />
  </svg>
);

export const Sprig = ({ className = "" }) => (
  <svg
    viewBox="0 0 80 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M40 4 V116"
      stroke="currentColor"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path
      d="M40 22 q -16 -2 -22 -14 q 14 0 22 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M40 36 q 16 -2 22 -14 q -14 0 -22 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M40 56 q -18 -2 -24 -14 q 16 0 24 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M40 72 q 18 -2 24 -14 q -16 0 -24 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M40 92 q -16 -2 -22 -14 q 14 0 22 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M40 108 q 16 -2 22 -14 q -14 0 -22 14 Z"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="currentColor"
      fillOpacity="0.08"
    />
  </svg>
);
